import type { FC, ReactElement } from "react"

type TProps = { color: string }

const Icon: FC<TProps> = ({ color }: TProps): ReactElement => (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.5 0.5H13.5C14.3284 0.5 15 1.17157 15 2V13C15 13.8284 14.3284 14.5 13.5 14.5H11V5C11 4.17157 10.3284 3.5 9.5 3.5H5V2C5 1.17157 5.67157 0.5 6.5 0.5Z"
            stroke={color}
        />
        <rect x="1" y="3.5" width="10" height="14" rx="1.5" stroke={color} />
    </svg>
)

Icon.displayName = "CopyIcon"

export { Icon as CopyIcon }
